import { Form, Link, NavLink } from "react-router";
import SocialMediaIcons from "../SocialMediaIcons";

const MenuHeader: React.FC<{
  toggleMenu: () => void;
  toggleNotificationsPanel: () => void;
  notifications: boolean;
}> = ({ toggleMenu, toggleNotificationsPanel, notifications }) => {
  return (
    <header className="fixed flex justify-between items-center box-border bg-jiwe-dark-blue py-4 px-5 lg:hidden w-full">
      <div className="flex gap-2 -mr-6">
        <Link to="/profile" onClick={() => toggleMenu()}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <path
              d="M12,.563a12,12,0,1,0,12,12A12,12,0,0,0,12,.563Zm0,4.645A4.258,4.258,0,1,1,7.742,9.466,4.258,4.258,0,0,1,12,5.208Zm0,16.645a9.272,9.272,0,0,1-7.089-3.3,5.4,5.4,0,0,1,4.766-2.894,1.184,1.184,0,0,1,.344.053A6.407,6.407,0,0,0,12,16.046a6.382,6.382,0,0,0,1.979-.334,1.184,1.184,0,0,1,.344-.053,5.4,5.4,0,0,1,4.766,2.894A9.272,9.272,0,0,1,12,21.853Z"
              transform="translate(0 -0.563)"
              fill="#fff"
            />
          </svg>
        </Link>
        <button
          className="border-0 p-0 m-0 bg-[transparent] relative"
          id="view-notifications"
          type="button"
          onClick={() => toggleNotificationsPanel()}
        >
          {notifications && (
            <span className="absolute top-0 right-0 w-2 h-2 bg-jiwe-alt-yellow rounded-full" />
          )}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className="text-[#fff] size-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0M3.124 7.5A8.969 8.969 0 0 1 5.292 3m13.416 0a8.969 8.969 0 0 1 2.168 4.5"
            />
          </svg>
        </button>
      </div>

      <Link to="/" onClick={() => toggleMenu()}>
        <img src="/assets/logo.png" alt="logo" className="h-[3rem]" />
      </Link>
      <button type="button" onClick={() => toggleMenu()}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <circle
            id="Ellipse_1"
            data-name="Ellipse 1"
            cx="12"
            cy="12"
            r="12"
            fill="#fff"
          />
          <g
            id="Group_3"
            data-name="Group 3"
            transform="translate(-13.636 -16.636)"
          >
            <line
              id="Line_6"
              data-name="Line 6"
              x2="14.142"
              transform="translate(20.636 33.636) rotate(-45)"
              fill="none"
              stroke="#143040"
              strokeWidth="2"
            />
            <line
              id="Line_7"
              data-name="Line 7"
              x2="14.142"
              transform="translate(20.636 23.636) rotate(45)"
              fill="none"
              stroke="#143040"
              strokeWidth="2"
            />
          </g>
        </svg>
      </button>
    </header>
  );
};

const MobileMenu: React.FC<{
  isLoggedIn: boolean;
  notifications: boolean;
  toggleMenu: () => void;
  toggleNotificationsPanel: () => void;
}> = ({ toggleMenu, isLoggedIn, toggleNotificationsPanel, notifications }) => {
  return (
    <nav className="lg:hidden flex flex-col bg-jiwe-dark-blue w-screen h-screen min-h-screen">
      <MenuHeader
        toggleMenu={toggleMenu}
        toggleNotificationsPanel={toggleNotificationsPanel}
        notifications={notifications}
      />
      <ul className="flex flex-col text-grey-light uppercase text-2xl gap-y-6 items-center mt-[12rem]">
        <li>
          <Link to="/" onClick={() => toggleMenu()}>
            Home
          </Link>
        </li>
        <li>
          <Link to="/games" onClick={() => toggleMenu()}>
            Games
          </Link>
        </li>
        <li>
          <Link to="/tournaments" onClick={() => toggleMenu()}>
            Tournaments
          </Link>
        </li>
        <li>
          <Link to="/hubs" onClick={() => toggleMenu()}>
            Hubs
          </Link>
        </li>
        {/* <li>
          <Link to="/results">
            Results &<br />
            Standings
          </Link>
        </li>
        <li>
          <Link to="/stats">Stats</Link>
        </li>
        <li>
          <Link to="/live-events">Live Events</Link>
        </li> */}
        {isLoggedIn ? (
          <>
            <li className="mt-12">
              <Link to="/profile" onClick={() => toggleMenu()}>
                My Profile
              </Link>
            </li>
            <li className="mt-4">
              <Form action="/logout" method="post">
                <button type="submit" className="uppercase">
                  Logout
                </button>
              </Form>
            </li>
          </>
        ) : (
          <li className="mt-4">
            <Link
              to="/login"
              onClick={() => toggleMenu()}
              className="flex items-center gap-x-1"
            >
              <span>Login</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
                className="size-6 text-jiwe-orange"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15M12 9l3 3m0 0-3 3m3-3H2.25"
                />
              </svg>
            </Link>
          </li>
        )}
      </ul>
      <div className="mt-16 mx-auto">
        <SocialMediaIcons colour="#B0B4B9" />
      </div>
      <div className="mt-8 mx-auto">
        <ul className="flex text-grey-darker gap-x-4 mb-2 !font-noto-sans-cond !text-base font-bold">
          <li>
            <NavLink to="/privacy-policy" prefetch="intent">
              Privacy Policy
            </NavLink>
          </li>
          <li>
            <NavLink to="/terms-and-conditions" prefetch="intent">
              Terms & Conditions
            </NavLink>
          </li>
        </ul>
      </div>

      <div className="text-grey-light mt-auto mb-10 text-center">
        <hr className="m-auto my-4 mx-[30%] bg-grey-light opacity-50" />
        &copy; Jiwe Interactive, {new Date().getFullYear()}
      </div>
    </nav>
  );
};

export default MobileMenu;
